import {
  BaseQueryFn,
  createApi,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../dynamicBaseQuery";
import {
  activeEventData,
  ActiveMatchesCom,
  ActiveUserReq,
  ActiveUserRes,
  AllParentLedgerReq,
  AllParentLedgerRes,
  appDetailsRes,
  blockBettingPayload,
  blockBettingRes,
  CasinoLedgerPayload,
  CasinoLedgerResponse,
  CasinoPlusMinus,
  CasinoPlusMinusProps,
  CasinoPlusMinusRes,
  casinoResponse,
  casioBetListReq,
  casioBetListRes,
  ChanelRes,
  ChangePaaReq,
  ChangePaaRes,
  ChannelDetail,
  channelReq,
  ClientLimitReq,
  ClientLimitRes,
  ClientPlusMinusReq,
  ClientPlusMinusRes,
  clientRequest,
  clientResponse,
  completdLedgerReqest,
  CompletedLedgerRes,
  completedProps,
  completedReq,
  CreateDetailsPayload,
  DataReportReq,
  DataReportRes,
  DeletedBetById,
  DeletedBetByIdByTime,
  deletedEvent,
  deletedEventId,
  deletedEventRes,
  EventDataRes,
  eventLockReq,
  FancyBookReq,
  FancyBookRes,
  LedgerBody,
  LedgerCasinoListRes,
  LedgerCasinoListResponse,
  LedgerDetailsReq,
  LedgerDetailsRes,
  LedgerPaylod,
  LedgerPostCasinoReq,
  LedgerPostReq,
  LedgerPostRes,
  LimitReq,
  LoginReportReq,
  LoginReportRes,
  LogOutRes,
  MatchBetForDeleted,
  MatchBetsRes,
  matchedBetResForDeleted,
  MatchSessionReq,
  MatchSessionRes,
  matkaBetPlacePayload,
  matkaListRes,
  matkaListResponse,
  matkaPayload,
  myLedgerReq,
  myLedgerRes,
  OddsPnlReq,
  OddsResponse,
  postledgerReq,
  PostledgerRes,
  SessionBetForDeleted,
  SessionBetResForDeleted,
  SessionBetsRes,
  SessionHavingRes,
  SessionPlusMinusRes,
  UpdateChannelId,
  updateLimitReq,
  updateLimitRes,
  UpdateUserRes,
  useNameRequest,
  useNameRes,
  UserCreateBody,
  UserCreateRequestBody,
  UserCreateResBody,
  UserDetailsUpdateReq,
  UserDetailsUpdateRes,
  UserProfile,
  UserRequestBody,
  UserResponse,
  TvUrlReq,
  TvUrlRes,
} from "./user";
import SetMessage from "../../../Pages/SetMessage/SetMessage";

export const userList = createApi({
  reducerPath: "userList",
  baseQuery: dynamicBaseQuery as BaseQueryFn<
    string | { url: string; method: string; body?: any },
    unknown,
    FetchBaseQueryError
  >,
  endpoints: (build) => ({
    userList: build.mutation<UserResponse, UserRequestBody>({
      query: (body) => ({
        url: "/user/list-user",
        method: "POST",
        body,
      }),
    }),
    userName: build.mutation<useNameRes, useNameRequest>({
      query: (body) => ({
        url: "/user/username-id-search",
        method: "POST",
        body,
      }),
    }),
    userDetailForEdit: build.mutation<any, UserCreateRequestBody>({
      query: (body) => ({
        url: "/user/get-detail-for-user-creation",
        method: "POST",
        body,
      }),
    }),
    userCreate: build.mutation<UserCreateResBody, UserCreateBody>({
      query: (body) => ({
        url: "/user/create",
        method: "POST",
        body,
      }),
    }),
    userProfile: build.mutation<UserProfile, void>({
      query: () => ({
        url: "/user/get-self-profile",
        method: "POST",
      }),
    }),
    ChangePassword: build.mutation<ChangePaaRes, ChangePaaReq>({
      query: (body) => ({
        url: "/user/changepassword-self",
        method: "POST",
        body,
      }),
    }),
    userDetailEdit: build.mutation<UserDetailsUpdateRes, UserDetailsUpdateReq>({
      query: (body) => ({
        url: "/user/user-detail-for-edit",
        method: "POST",
        body,
      }),
    }),
    userActive: build.mutation<ActiveUserRes, ActiveUserReq>({
      query: (body) => ({
        url: "/user/activate-deactivate-user",
        method: "POST",
        body,
      }),
    }),
    LedgerDepositWidthdraw: build.mutation<LedgerBody, LedgerPaylod>({
      query: (body) => ({
        url: "/ledger/ledger-dep-wid",
        method: "POST",
        body,
      }),
    }),
    LedgerDetails: build.mutation<LedgerDetailsRes, LedgerDetailsReq>({
      query: (body) => ({
        url: "/ledger/get-ledger-cash-trans-userid",
        method: "POST",
        body,
      }),
    }),
    getClientDetails: build.mutation<clientResponse, clientRequest>({
      query: (body) => ({
        url: "/report/client-having-active-bets-odds-session",
        method: "POST",
        body,
      }),
    }),
    getMatchandSessionBet: build.mutation<MatchSessionRes, any>({
      query: (body) => ({
        url: "/report/get-match-session-bets",
        method: "POST",
        body,
      }),
    }),
    getClientActiveBet: build.mutation<clientResponse, clientRequest>({
      query: (body) => ({
        url: "/report/client-having-active-bets-odds",
        method: "POST",
        body,
      }),
    }),
    getClientFancyBet: build.mutation<clientResponse, clientRequest>({
      query: (body) => ({
        url: "/report/client-having-active-bets-fancy",
        method: "POST",
        body,
      }),
    }),
    getSessionHavingBetBet: build.mutation<SessionHavingRes, clientRequest>({
      query: (body) => ({
        url: "/report/session-having-bets",
        method: "POST",
        body,
      }),
    }),
    getMatchBets: build.mutation<MatchBetsRes, MatchSessionReq>({
      query: (body) => ({
        url: "/report/get-match-bets",
        method: "POST",
        body,
      }),
    }),
    getSessionBet: build.mutation<SessionBetsRes, MatchSessionReq>({
      query: (body) => ({
        url: "/report/get-session-bets",
        method: "POST",
        body,
      }),
    }),
    LogOut: build.mutation<LogOutRes, void>({
      query: (body) => ({
        url: "/login/logout",
        method: "POST",
        body,
      }),
    }),
    getSessionPlusMinus: build.mutation<SessionPlusMinusRes, clientRequest>({
      query: (body) => ({
        url: "/report/get-session-plus-minus",
        method: "POST",
        body,
      }),
    }),
    getCompletedEvent: build.mutation<completedProps, completedReq>({
      query: (body) => ({
        url: "/sports/get-completed-events",
        method: "POST",
        body,
      }),
    }),
    getFancyBook: build.mutation<FancyBookRes, FancyBookReq>({
      query: (body) => ({
        url: "/enduser/fancy-book",
        method: "POST",
        body,
      }),
    }),
    getClientListForLimit: build.mutation<ClientLimitRes, ClientLimitReq>({
      query: (body) => ({
        url: "/user/child-list-for-limit",
        method: "POST",
        body,
      }),
    }),
    getUpdateLimit: build.mutation<updateLimitRes, updateLimitReq>({
      query: (body) => ({
        url: "/user/update-limit",
        method: "POST",
        body,
      }),
    }),
    getCompletedLedger: build.mutation<
      CompletedLedgerRes,
      completdLedgerReqest
    >({
      query: (body) => ({
        url: "/report/get-complete-ledger",
        method: "POST",
        body,
      }),
    }),
    getDataReport: build.mutation<DataReportRes, DataReportReq>({
      query: (body) => ({
        url: "/user-activity-report/get-user-activity",
        method: "POST",
        body,
      }),
    }),
    getLoginReport: build.mutation<LoginReportRes, LoginReportReq>({
      query: (body) => ({
        url: "/login-report/user-login-report",
        method: "POST",
        body,
      }),
    }),
    getOddsPnl: build.mutation<OddsResponse, OddsPnlReq>({
      query: (body) => ({
        url: "/report/odds-pnl",
        method: "POST",
        body,
      }),
    }),
    getPnl: build.mutation<OddsResponse, OddsPnlReq>({
      query: (body) => ({
        url: "/user/child-list-for-limit",
        method: "POST",
        body,
      }),
    }),
    getLimit: build.mutation<OddsResponse, LimitReq>({
      query: (body) => ({
        url: "/user/child-list-for-limit",
        method: "POST",
        body,
      }),
    }),
    getUpdateUser: build.mutation<updateLimitRes, UpdateUserRes>({
      query: (body) => ({
        url: "/user/update-detail",
        method: "POST",
        body,
      }),
    }),
    getMyLedger: build.mutation<myLedgerRes, myLedgerReq>({
      query: (body) => ({
        url: "/ledger/my-ledger",
        method: "POST",
        body,
      }),
    }),
    getClientPlusMinus: build.mutation<ClientPlusMinusRes, ClientPlusMinusReq>({
      query: (body) => ({
        url: "/ledger/get-client-plus-minus",
        method: "POST",
        body,
      }),
    }),
    getAllParentLedger: build.mutation<AllParentLedgerRes, AllParentLedgerReq>({
      query: (body) => ({
        url: "/ledger/get-ledger-all-parent",
        method: "POST",
        body,
      }),
    }),
    getCasinoBetListQuery: build.query<casioBetListRes, casioBetListReq>({
      query: (body) => ({
        url: "/casino/casino-bet-list-admin",
        method: "POST",
        body,
      }),
    }),
    getCasinoBetList: build.mutation<casioBetListRes, casioBetListReq>({
      query: (body) => ({
        url: "/casino/casino-bet-list-admin",
        method: "POST",
        body,
      }),
    }),
    getCasinoList: build.query<casinoResponse, void>({
      query: (body) => ({
        url: "/casino/casino-list",
        method: "POST",
        body,
      }),
    }),
    getCasinoPlusMinus: build.mutation<casinoResponse, CasinoPlusMinus>({
      query: (body) => ({
        url: "/casino/get-casino-player-table-list",
        method: "POST",
        body,
      }),
    }),
    getCasinoLedger: build.mutation<CasinoLedgerResponse, CasinoLedgerPayload>({
      query: (body) => ({
        url: "/casino/get-casino-ledger",
        method: "POST",
        body,
      }),
    }),
    CasinoPlusMinus: build.mutation<CasinoPlusMinusRes, CasinoPlusMinusProps>({
      query: (body) => ({
        url: "/casino/get-casino-detail-daywise-plusminus",
        method: "POST",
        body,
      }),
    }),
    matchListPostledger: build.mutation<PostledgerRes, postledgerReq>({
      query: (body) => ({
        url: "/sports/match-list-postledger-androllback",
        method: "POST",
        body,
      }),
    }),
    postLedger: build.mutation<PostledgerRes, LedgerPostReq>({
      query: (body) => ({
        url: "/ledger/post-ledger",
        method: "POST",
        body,
      }),
    }),
    postLedgerCasino: build.mutation<LedgerPostRes, LedgerPostCasinoReq>({
      query: (body) => ({
        url: "/casino/post-ledger",
        method: "POST",
        body,
      }),
    }),
    casinoListLedger: build.mutation<
      LedgerCasinoListResponse,
      LedgerCasinoListRes
    >({
      query: (body) => ({
        url: "/casino/casino-list-ledger-rollback",
        method: "POST",
        body,
      }),
    }),
    casinoRollBack: build.mutation<LedgerPostRes, LedgerPostCasinoReq>({
      query: (body) => ({
        url: "/casino/rollback-ledger",
        method: "POST",
        body,
      }),
    }),
    ledgerRollBack: build.mutation<LedgerPostRes, LedgerPostReq>({
      query: (body) => ({
        url: "/ledger/rollback-ledger",
        method: "POST",
        body,
      }),
    }),
    getChanelId: build.mutation<ChanelRes, channelReq>({
      query: (body) => ({
        url: `/sports/channel-id-matchidwise`,
        method: "POST",
        body,
      }),
    }),
    getActiveEventList: build.mutation<EventDataRes, void>({
      query: (body) => ({
        url: `/sports/active-event-list`,
        method: "POST",
        body,
      }),
    }),
    getEventLock: build.mutation<LedgerPostRes, eventLockReq>({
      query: (body) => ({
        url: `/sports/upadte-event-activation`,
        method: "POST",
        body,
      }),
    }),
    getEventListForChannelid: build.mutation<EventDataRes, void>({
      query: (body) => ({
        url: `/sports/event-list-score-channelid-update`,
        method: "POST",
        body,
      }),
    }),
    getChannelDetail: build.mutation<ChannelDetail, void>({
      query: (body) => ({
        url: `/token-free/get-channel-detail-tp`,
        method: "GET",
        body,
      }),
    }),
    getUpdateChannel: build.mutation<LedgerPostRes, UpdateChannelId>({
      query: (body) => ({
        url: `/sports/update-channel-scoreid`,
        method: "POST",
        body,
      }),
    }),
    getCompletedMatchesActive: build.mutation<ActiveMatchesCom, void>({
      query: (body) => ({
        url: `/report/get-active-bets-of-completed-matches`,
        method: "POST",
        body,
      }),
    }),
    getEventLedgerNotPost: build.mutation<activeEventData, void>({
      query: (body) => ({
        url: `/sports/event-ledger-not-posted`,
        method: "POST",
        body,
      }),
    }),
    getSessionBetDeleted: build.mutation<
      SessionBetForDeleted,
      SessionBetResForDeleted
    >({
      query: (body) => ({
        url: `/report/get-session-bets-to-delete`,
        method: "POST",
        body,
      }),
    }),
    getMatchedBetDeleted: build.mutation<
      MatchBetForDeleted,
      matchedBetResForDeleted
    >({
      query: (body) => ({
        url: `/report/get-match-bets-to-delete`,
        method: "POST",
        body,
      }),
    }),
    getDeletdBet: build.mutation<LedgerPostRes, DeletedBetById>({
      query: (body) => ({
        url: `/superadmin/delete-bet-byid`,
        method: "POST",
        body,
      }),
    }),
    getDeletdBetByTime: build.mutation<LedgerPostRes, DeletedBetByIdByTime>({
      query: (body) => ({
        url: `/superadmin/delete-bet-bytime`,
        method: "POST",
        body,
      }),
    }),
    getEventDeleted: build.mutation<deletedEventRes, deletedEvent>({
      query: (body) => ({
        url: `/report/event-list-has-deleted-bets`,
        method: "POST",
        body,
      }),
    }),
    getEventDeletedById: build.mutation<deletedEventRes, deletedEventId>({
      query: (body) => ({
        url: `/report/deleted-bet-list-by-matachid`,
        method: "POST",
        body,
      }),
    }),
    getCraeteApp: build.mutation<CreateDetailsPayload, any>({
      query: (body) => ({
        url: `/app-detail/create`,
        method: "POST",
        body,
      }),
    }),
    getUpdateData: build.mutation<CreateDetailsPayload, any>({
      query: (body) => ({
        url: `/app-detail/update`,
        method: "POST",
        body,
      }),
    }),
    getAppDetails: build.mutation<appDetailsRes, void>({
      query: (body) => ({
        url: `/app-detail/app-detail-all`,
        method: "POST",
      }),
    }),
    getAppDetailsDownLine: build.mutation<appDetailsRes, void>({
      query: (body) => ({
        url: `/user/app-detail-allowed-forchange`,
        method: "POST",
      }),
    }),
    AllsessionBets: build.mutation<any, any>({
      query: (body) => ({
        url: `/report/all-session-bets`,
        method: "POST",
        body,
      }),
    }),
    matkaList: build.query<matkaListRes, void>({
      query: (body) => ({
        url: `/matka/list`,
        method: "POST",
        body,
      }),
    }),
    getMatkaMarket: build.mutation<matkaListResponse, matkaPayload>({
      query: (body) => ({
        url: `/matka/get-matka-market`,
        method: "POST",
        body,
      }),
    }),
    getMatkaBetList: build.mutation<any, any>({
      query: (body) => ({
        url: `/matka/get-matka-bets`,
        method: "POST",
        body,
      }),
    }),
    getMatkaBetBySid: build.mutation<any, any>({
      query: (body) => ({
        url: `/matka/get-mtk-bet-by-sid`,
        method: "POST",
        body,
      }),
    }),
    getMatkaLiability: build.mutation<any, any>({
      query: (body) => ({
        url: `/matka/get-matka-liability`,
        method: "POST",
        body,
      }),
    }),
    matkaPlacebet: build.mutation<any, matkaBetPlacePayload>({
      query: (body) => ({
        url: `/matka/matka-bet`,
        method: "POST",
        body,
      }),
    }),
    setMatkaResult: build.mutation<any, any>({
      query: (body) => ({
        url: `/matka/set-matka-result`,
        method: "POST",
        body,
      }),
    }),
    getMatkaPnl: build.mutation<any, any>({
      query: (body) => ({
        url: "/matka/matka-pnl",
        method: "POST",
        body,
      }),
    }),
    getMatkaBetDetails: build.mutation<any, any>({
      query: (body) => ({
        url: "/matka/get-mtk-bet-by-nameanddate",
        method: "POST",
        body,
      }),
    }),
    getAllBetsByMatchId: build.mutation<any, any>({
      query: (body) => ({
        url: `/ant-pro/list-all-bets-by-matchid`,
        method: "POST",
        body,
      }),
    }),
    getActiveFancyNew: build.mutation<any, any>({
      query: (agrs) => ({
        url: `activeFancyNew/${agrs.matchId}`,
        method: "GET",
      }),
    }),
    getMarketAnalysis: build.mutation<any, any>({
      query: (body) => ({
        url: `/report/market-analysis`,
        method: "POST",
        body,
      }),
    }),
    getUserParentShare: build.mutation<any, any>({
      query: (userId) => ({
        url: `/user/user-parent-share`,
        method: "POST",
        body: {
          userId,
        },
      }),
    }),
    getAccountStatement: build.mutation<any, any>({
      query: (body) => ({
        url: `/ant-pro/get-accstt-chpdtl`,
        method: "POST",
        body,
      }),
    }),
    // getAgentCommission: build.mutation<any, any>({
    //   query: (body) => ({
    //     url: `/ant-pro/get-commission-report`,
    //     method: "POST",
    //     body,
    //   }),
    // }),
    getAgentCommission: build.mutation<any, any>({
      query: (body) => ({
        url: `/report/get-commission-report-betguru`,
        method: "POST",
        body,
      }),
    }),
    getBlockBetting: build.mutation<blockBettingRes, blockBettingPayload>({
      query: (body) => ({
        url: `/ant-pro/bet-lock`,
        method: "POST",
        body,
      }),
    }),
    userCasinoLock: build.mutation({
      query: (body) => ({
        url: "/ant-pro/casino-bet-lock",
        method: "POST",
        body,
      }),
    }),
    userMatkaLock: build.mutation({
      query: (body) => ({
        url: "/ant-pro/matka-bet-lock",
        method: "POST",
        body,
      }),
    }),
    getCommissionReportClientWise: build.mutation<any, any>({
      query: (body) => ({
        url: `/ant-pro/get-commission-report-clientwise`,
        method: "POST",
        body,
      }),
    }),
    getUserBetLiability: build.mutation<any, any>({
      query: (userId) => ({
        url: `/ant-pro/get-user-bet-liability`,
        method: "POST",
        body: { userId },
      }),
    }),
    selfDeposit: build.mutation<any, any>({
      query: (body) => ({
        url: "/superadmin/self-deposit",
        method: "POST",
        body,
      }),
    }),
    ledgerProfitLoss: build.mutation<any, any>({
      query: (body) => ({
        url: "/ant-pro/ledger-profit-loss",
        method: "POST",
        body,
      }),
    }),
    getMessage: build.query<any, { panelName: string }>({
      query: (body) => ({
        url: "message/get-message",
        method: "POST",
        body,
      }),
    }),
    setMessage: build.mutation<any, any>({
      query: (body) => ({
        url: "message/set-message",
        method: "POST",
        body,
      }),
    }),
    generateOtpPass: build.mutation<any, any>({
      query: (body) => ({
        url: "user/get-userdetail-toshare",
        method: "POST",
        body,
      }),
    }),
    getTvUrl: build.mutation<TvUrlRes, TvUrlReq>({
      query: (body) => ({
        url: "https://api.antpro999.net/ant-pro/get-tv-url",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useUserListMutation,
  useUserNameMutation,
  useUserDetailForEditMutation,
  useUserCreateMutation,
  useUserProfileMutation,
  useChangePasswordMutation,
  useUserDetailEditMutation,
  useUserActiveMutation,
  useLedgerDepositWidthdrawMutation,
  useLedgerDetailsMutation,
  useGetClientDetailsMutation,
  useGetMatchandSessionBetMutation,
  useGetClientActiveBetMutation,
  useGetMatchBetsMutation,
  useGetClientFancyBetMutation,
  useGetSessionHavingBetBetMutation,
  useGetSessionBetMutation,
  useLogOutMutation,
  useGetSessionPlusMinusMutation,
  useGetCompletedEventMutation,
  useGetFancyBookMutation,
  useGetClientListForLimitMutation,
  useGetUpdateLimitMutation,
  useGetCompletedLedgerMutation,
  useGetDataReportMutation,
  useGetLoginReportMutation,
  useGetOddsPnlMutation,
  useGetLimitMutation,
  useGetUpdateUserMutation,
  useGetMyLedgerMutation,
  useGetClientPlusMinusMutation,
  useGetAllParentLedgerMutation,
  useGetCasinoBetListMutation,
  useGetCasinoListQuery,
  useGetCasinoPlusMinusMutation,
  useGetCasinoLedgerMutation,
  useCasinoPlusMinusMutation,
  useGetCasinoBetListQueryQuery,
  useMatchListPostledgerMutation,
  usePostLedgerMutation,
  usePostLedgerCasinoMutation,
  useCasinoListLedgerMutation,
  useCasinoRollBackMutation,
  useLedgerRollBackMutation,
  useGetChanelIdMutation,
  useGetActiveEventListMutation,
  useGetEventLockMutation,
  useGetEventListForChannelidMutation,
  useGetChannelDetailMutation,
  useGetUpdateChannelMutation,
  useGetCompletedMatchesActiveMutation,
  useGetEventLedgerNotPostMutation,
  useGetSessionBetDeletedMutation,
  useGetDeletdBetMutation,
  useGetMatchedBetDeletedMutation,
  useGetDeletdBetByTimeMutation,
  useGetEventDeletedMutation,
  useGetEventDeletedByIdMutation,
  useGetCraeteAppMutation,
  useGetAppDetailsMutation,
  useGetUpdateDataMutation,
  useAllsessionBetsMutation,
  useMatkaListQuery,
  useGetMatkaMarketMutation,
  useGetMatkaBetListMutation,
  useGetMatkaBetBySidMutation,
  useGetMatkaLiabilityMutation,
  useMatkaPlacebetMutation,
  useSetMatkaResultMutation,
  useGetMatkaPnlMutation,
  useGetMatkaBetDetailsMutation,
  useGetAllBetsByMatchIdMutation,
  useGetActiveFancyNewMutation,
  useGetMarketAnalysisMutation,
  useGetUserParentShareMutation,
  useGetAccountStatementMutation,
  useGetAgentCommissionMutation,
  useGetBlockBettingMutation,
  useGetCommissionReportClientWiseMutation,
  useGetUserBetLiabilityMutation,
  useSelfDepositMutation,
  useLedgerProfitLossMutation,
  useGetAppDetailsDownLineMutation,
  useGetMessageQuery,
  useSetMessageMutation,
  useUserCasinoLockMutation,
  useUserMatkaLockMutation,
  useGenerateOtpPassMutation,
  useGetTvUrlMutation,
} = userList;
